module.exports = __webpack_public_path__ + "4d8d1a13.png";